// prettier-ignore
const dictionary = {
  ERROR_ENTER_NAME:'Please enter your name',
  ERROR_ENTER_PASSWORD:'Please enter your password',
  ERROR_USER_NOT_FOUND:'User not found, please verify your credentials',
  LABEL_ACTIVITIES_GIFT_10: 'New gift for',
  LABEL_ACTIVITIES_LOST_GIFT: 'Gift lost for',
  LABEL_ACTIVITIES_LOST_POINT: 'Point lost for',
  LABEL_ACTIVITIES_NFC: 'NFC card',
  LABEL_ACTIVITIES_POINT: 'New point for',
  LABEL_ACTIVITIES_POINTS: 'Points',
  LABEL_ACTIVITIES_UNKNOWN_ACTION: 'Activity not found',
  LABEL_ACTIVITIES_DATE: 'Date',
  LABEL_ACTIVITIES_DETAIL:'Detail',
  LABEL_ACTIVITIES_LOCAL:'Local',
  LABEL_ACTIVITIES_NO_ACTIVITIES:'There are no activities',
  LABEL_ACTIVITIES_NO_LOCAL:'No local',
  LABEL_ACTIVITIES_FROM: 'From',
  LABEL_ACTIVITIES_TO: 'To',
  LABEL_ACTIVITIES_CLEAR_FILTERS: 'Clear filters',
  LABEL_ALERTS_TITLE: 'Alerts',
  LABEL_ACCOUNTS_TITLE: 'Web accounts',
  LABEL_ACCOUNTS_SUBTITLE: "The dashboard's password accounts. A new account gets an invitation to choose its password.",
  LABEL_ACCOUNTS_NEW: 'New account',
  LABEL_ACCOUNTS_NEW_HINT: "We'll email an invitation to choose a password (valid 48 h).",
  LABEL_ACCOUNTS_EDIT: 'Edit the account',
  LABEL_ACCOUNTS_ACCOUNT: 'Account',
  LABEL_ACCOUNTS_COMPANY: 'Shop',
  LABEL_ACCOUNTS_STATUS: 'Status',
  LABEL_ACCOUNTS_INVITATION: 'Invitation',
  LABEL_ACCOUNTS_LAST_SEEN: 'Last access',
  LABEL_ACCOUNTS_EMAIL: 'Email',
  LABEL_ACCOUNTS_NAME: 'Name',
  LABEL_ACCOUNTS_CHOOSE_COMPANY: 'Choose the shop',
  LABEL_ACCOUNTS_CANCEL: 'Cancel',
  LABEL_ACCOUNTS_SAVE: 'Save',
  LABEL_ACCOUNTS_CREATE: 'Create and send the invitation',
  LABEL_ACCOUNTS_ACTIVE: 'Active',
  LABEL_ACCOUNTS_SUSPENDED: 'Suspended',
  LABEL_ACCOUNTS_NEVER: 'Never',
  LABEL_ACCOUNTS_INVITATION_ACCEPTED: 'Accepted',
  LABEL_ACCOUNTS_INVITATION_PENDING: 'Pending',
  LABEL_ACCOUNTS_INVITATION_EXPIRED: 'Expired',
  LABEL_ACCOUNTS_INVITATION_UNTIL: 'Valid until {0}',
  LABEL_ACCOUNTS_RESEND: 'Resend the invitation',
  LABEL_ACCOUNTS_SUSPEND: 'Suspend',
  LABEL_ACCOUNTS_REACTIVATE: 'Reactivate',
  LABEL_ACCOUNTS_DELETE: 'Delete the account',
  LABEL_ACCOUNTS_DELETE_CONFIRM: 'The account {0} will be deleted for good.',
  LABEL_ACCOUNTS_CREATED: 'Account created, invitation sent to {0}',
  LABEL_ACCOUNTS_SAVED: 'Account saved',
  LABEL_ACCOUNTS_INVITATION_SENT: 'Invitation sent to {0}',
  LABEL_ACCOUNTS_DELETED: 'Account {0} deleted',
  LABEL_ACCOUNTS_ERROR: 'Something went wrong, please try again',
  LABEL_ACCOUNTS_ERROR_ACCOUNT_EXISTS: 'An account already exists with this email',
  LABEL_ACCOUNTS_ERROR_INVALID_EMAIL: 'Invalid email',
  LABEL_ACCOUNTS_ERROR_COMPANY_NOT_FOUND: 'Shop not found',
  LABEL_ACCOUNTS_ERROR_INVITATION_NOT_SENT: 'The account exists but the invitation was not sent: resend it',
  LABEL_ACCOUNTS_ERROR_ALREADY_ACCEPTED: 'This account already chose its password',
  LABEL_CONNECTIONS_TITLE: 'Dashboard connections',
  LABEL_CONNECTIONS_SUBTITLE: 'Who uses the web dashboard and when. A new visit starts after 30 min without activity.',
  LABEL_CONNECTIONS_DAYS: '{0} days',
  LABEL_CONNECTIONS_WITH_ADMINS: 'Include admins',
  LABEL_CONNECTIONS_ACCOUNTS: 'Accounts',
  LABEL_CONNECTIONS_ACCOUNT: 'Account',
  LABEL_CONNECTIONS_COMPANY: 'Shop',
  LABEL_CONNECTIONS_LAST_SEEN: 'Last access',
  LABEL_CONNECTIONS_VISITS: 'Visits',
  LABEL_CONNECTIONS_TIME: 'Time',
  LABEL_CONNECTIONS_VISITS_TITLE: 'Visits',
  LABEL_CONNECTIONS_SHOWING: '{0} of {1}',
  LABEL_CONNECTIONS_STARTED: 'Start',
  LABEL_CONNECTIONS_DURATION: 'Duration',
  LABEL_CONNECTIONS_ORIGIN: 'Origin',
  LABEL_CONNECTIONS_DEVICE: 'Browser',
  LABEL_CONNECTIONS_VIA_LOGIN: 'Sign-in',
  LABEL_CONNECTIONS_VIA_SESSION: 'Open session',
  LABEL_CONNECTIONS_NEVER: 'Never',
  LABEL_CONNECTIONS_AGO_MINUTES: '{0} min ago',
  LABEL_CONNECTIONS_AGO_HOURS: '{0} h ago',
  LABEL_CONNECTIONS_AGO_DAYS: '{0} days ago',
  LABEL_CONNECTIONS_NO_ACCOUNTS: 'No dashboard accounts',
  LABEL_CONNECTIONS_NO_VISITS: 'No visits in this period',
  LABEL_CONNECTIONS_ERROR: 'The connections could not be loaded',
  LABEL_ALERTS_SUBTITLE: 'Unusual uses of the system, found when points are given. Nothing is ever blocked.',
  LABEL_ALERTS_TOTAL: 'alerts',
  LABEL_ALERTS_FILTER_ALL: 'All',
  LABEL_ALERTS_TYPE_OUTSIDE_HOURS: 'Outside hours',
  LABEL_ALERTS_TYPE_TWO_LOCALS: 'Two locals',
  LABEL_ALERTS_DATE: 'Date',
  LABEL_ALERTS_TYPE: 'Type',
  LABEL_ALERTS_CUSTOMER: 'Customer',
  LABEL_ALERTS_LOCAL: 'Local',
  LABEL_ALERTS_POINTS: 'Points',
  LABEL_ALERTS_DETAIL: 'Detail',
  LABEL_ALERTS_EMPTY: 'No alerts so far',
  LABEL_ALERTS_DETAIL_OUTSIDE_HOURS: "Points given at {0}, outside the day's opening hours ({1})",
  LABEL_ALERTS_DETAIL_CLOSED_DAY: 'Points given at {0}, on a day the local is closed',
  LABEL_ALERTS_DETAIL_TWO_LOCALS: '{0} min after a point at {1}',
  LABEL_DASHBOARD_HEATMAP_POINTS: 'Points given',
  LABEL_DASHBOARD_HEATMAP_POINTS_UNIT: 'points',
  LABEL_DASHBOARD_HEATMAP_CLOSED: 'Closed',
  LABEL_DASHBOARD_HEATMAP_CLOSED_POINTS: 'Points given outside hours',
  LABEL_ACTIVITIES_FILTER_ALL: 'All',
  LABEL_ACTIVITIES_FILTER_POINT: 'Points given',
  LABEL_ACTIVITIES_FILTER_LOST_POINT: 'Points lost',
  LABEL_ACTIVITIES_FILTER_GIFT: 'Gifts given',
  LABEL_ACTIVITIES_FILTER_LOST_GIFT: 'Gifts lost',
  LABEL_AUDIT_TITLE: 'Audit',
  LABEL_AUDIT_TOTAL: 'entries',
  LABEL_AUDIT_SEARCH: 'Search: user, IP, id, value…',
  LABEL_AUDIT_ALL_TABLES: 'All tables',
  LABEL_AUDIT_ALL_OPERATIONS: 'All operations',
  LABEL_AUDIT_CREATE: 'Created',
  LABEL_AUDIT_UPDATE: 'Updated',
  LABEL_AUDIT_DELETE: 'Deleted',
  LABEL_AUDIT_DATE: 'Date',
  LABEL_AUDIT_TABLE: 'Table',
  LABEL_AUDIT_OPERATION: 'Operation',
  LABEL_AUDIT_RECORD: 'Record',
  LABEL_AUDIT_CHANGES: 'Changes',
  LABEL_AUDIT_USER: 'User',
  LABEL_AUDIT_SYSTEM: 'system',
  LABEL_AUDIT_BEFORE: 'Before',
  LABEL_AUDIT_AFTER: 'After',
  LABEL_AUDIT_EMPTY: 'No entries',
  LABEL_RATING_TITLE: 'App ratings',
  LABEL_RATING_TOTAL: 'ratings',
  LABEL_RATING_AVERAGE: 'Average',
  LABEL_RATING_ALL: 'All',
  LABEL_RATING_LOW: '3 or less',
  LABEL_RATING_DATE: 'Date',
  LABEL_RATING_NOTE: 'Rating',
  LABEL_RATING_CUSTOMER: 'Customer',
  LABEL_RATING_ACCOUNT: 'Account',
  LABEL_RATING_SHOPS: 'Shops',
  LABEL_RATING_LAST_VISIT: 'Last visit',
  LABEL_RATING_CONNECTIONS: 'Sign-ins',
  LABEL_RATING_CONTACT: 'Contact',
  LABEL_RATING_NO_DATE: 'No date',
  LABEL_RATING_NEVER: 'Never',
  LABEL_RATING_STAFF: 'Staff',
  LABEL_RATING_NO_CONTACT: 'No contact',
  LABEL_RATING_FIREBASE: 'ID to look up in Firebase',
  LABEL_RATING_EMPTY: 'No ratings',
  LABEL_VERSIONS_TITLE: "App versions",
  LABEL_VERSIONS_ACTIVE_USERS: "active users",
  LABEL_VERSIONS_LAST_DAYS: "Last {0} days",
  LABEL_VERSIONS_SCOPE_ALL: "All users",
  LABEL_VERSIONS_SCOPE_COMPANY: "Customers of {0}",
  LABEL_VERSIONS_ON_LATEST: "{0} of {1} on {2}",
  LABEL_VERSIONS_STORE_UNKNOWN: "Store unreachable: using the newest version seen",
  LABEL_VERSIONS_NO_DATA: "No data yet",
  LABEL_VERSIONS_HINT: "Data builds up as users open the app: each user counts once, with the version of their latest use.",
  LABEL_VERSIONS_BY_VERSION: "By version",
  LABEL_VERSIONS_PLATFORM: "Platform",
  LABEL_VERSIONS_VERSION: "Version",
  LABEL_VERSIONS_USERS: "Users",
  LABEL_VERSIONS_LAST_SEEN: "Last use",
  LABEL_VERSIONS_BEHIND: "Users on an older version",
  LABEL_VERSIONS_ALL_UP_TO_DATE: "Everyone is on the latest version",
  LABEL_VERSIONS_UP_TO_201: "2.0.1 or older",
  LABEL_VERSIONS_14X: "1.4.x (very old)",
  LABEL_VERSIONS_OLDER: "Older than 2.0.1 (build {0})",
  LABEL_ADVERTISING_AGE:'Age',
  LABEL_ADVERTISING_ALERT_PICTURE:'Please confirm you want to remove your picture',
  LABEL_ADVERTISING_CITY:'City',
  LABEL_ADVERTISING_COUNTRY:'Country',
  LABEL_ADVERTISING_GENDER:'Gender',
  LABEL_ADVERTISING_REGION:'Region',
  LABEL_ADVERTISING_TITLE_PICTURE:'Remove picture',
  LABEL_ADVERTISING_WARNING_CHOOSE:'You should choose an option',
  LABEL_ADVERTISING_WARNING_LOAD_IMAGE:'Please upload an image',
  LABEL_ADVERTISING_WEBSITE:'Website',
  LABEL_BUTTON_BACK:'Back',
  LABEL_BUTTON_CANCEL:'Cancel',
  LABEL_BUTTON_CONFIRM:'Confirm',
  LABEL_BUTTON_CONTACT:'Contact Us',
  LABEL_BUTTON_DELETE:'Delete',
  LABEL_BUTTON_RETRIEVE_PASSWORD: 'Retrieve password',
  LABEL_BUTTON_SAVE:'Save',
  LABEL_BUTTON_SIGNIN:'Sign in',
  LABEL_COMPANIES_ALERT_DELETE_CONTENT: 'You are about to delete this business, please confirm',
  LABEL_COMPANIES_ALERT_DELETE_TITLE: 'Delete a business',
  LABEL_COMPANIES_CHANGE_PICTURE: 'Change image',
  LABEL_COMPANIES_CODE_ERROR: 'Code must be 3 uppercase letters followed by 4 digits',
  LABEL_COMPANIES_ERROR_IMAGE_SIZE: 'Your image must be at least {0}px long x {1}px high; the size of the image you indicated is {2}px long x {3}px high',
  LABEL_COMPANIES_FEEDBACK: 'Feedback',
  LABEL_COMPANIES_FEEDBACK_TYPE: 'Determines if feedback is activated',
  LABEL_COMPANIES_GIFT_EXPIRATION_ERROR: 'It must be a number greater than 3 days',
  LABEL_COMPANIES_GUIDE: 'Printable guide',
  LABEL_COMPANIES_REPORT: 'Weekly report',
  LABEL_COMPANIES_REPORT_PREVIOUS_WEEK: 'Previous week',
  LABEL_COMPANIES_REPORT_NEXT_WEEK: 'Next week',
  LABEL_COMPANIES_REPORT_CURRENT_WEEK: 'Current week',
  LABEL_COMPANIES_REPORT_ERROR: 'The report could not be generated',
  LABEL_COMPANIES_GUIDE_ERROR: 'Error while generating the guide',
  LABEL_COMPANIES_GUIDE_INCOMPLETE: 'Finish setting up the business before generating the guide. Missing: {0}.',
  LABEL_COMPANIES_GUIDE_MISSING_GIFTS: 'the gifts',
  LABEL_COMPANIES_GUIDE_MISSING_REQUIREMENT: 'the condition to earn a point',
  LABEL_COMPANIES_HEADER_ACTION: 'Action',
  LABEL_COMPANIES_HEADER_CODE: 'Code',
  LABEL_COMPANIES_HEADER_ID: 'Id',
  LABEL_COMPANIES_HEADER_COUNTRY: 'Country',
  LABEL_COMPANIES_HEADER_NAME: 'Business name',
  LABEL_COMPANIES_HEADER_TYPE: 'Type',
  LABEL_COMPANIES_NAME_COMPANY_PICTURE: 'The name of your company',
  LABEL_COMPANIES_NAME_ERROR: 'The name must be between 5 and 60 characters and contain only letters, numbers, or spaces',
  LABEL_COMPANIES_NO_PICTURE: 'No image',
  LABEL_COMPANIES_PICTURE_MINIMUM: 'Please upload an image (minimum {0}px long x {1}px high)',
  LABEL_COMPANIES_POINT_EXPIRATION_ERROR: 'It must be a number greater than 3 days',
  LABEL_COMPANIES_PRIVATE: 'Private',
  LABEL_COMPANIES_PUBLIC: 'Public',
  LABEL_COMPANIES_REQUIREMENT_ERROR: 'Indicate only letters, numbers, or spaces',
  LABEL_COMPANIES_SEARCH: 'Search businesses',
  LABEL_COMPANIES_TOOLTIP_CODE: 'Indicate the code for this business.',
  LABEL_COMPANIES_TOOLTIP_FACEBOOK: 'Indicate your Facebook page in this format: https://www.facebook.com/Fidelize',
  LABEL_COMPANIES_TOOLTIP_GIFT_EXPIRATION: 'Indicate how long your clients will have to redeem their gift',
  LABEL_COMPANIES_TOOLTIP_INSTAGRAM: 'Indicate your Instagram page in this format: https://instagram.com/fidelize.chile',
  LABEL_COMPANIES_TOOLTIP_EMAIL: "Email address that receives the shop's alerts and reports. Never shown to customers",
  LABEL_COMPANIES_TOOLTIP_NAME: 'Choose a name for your company; this name will be used throughout the Fidelize network',
  LABEL_COMPANIES_TOOLTIP_POINT_EXPIRATION: 'Indicate the inactivity period necessary to lose a point.',
  LABEL_COMPANIES_TOOLTIP_REQUIREMENT: 'Indicate the condition for accumulating a point.',
  LABEL_COMPANIES_TOOLTIP_TYPE: 'Determines if the company will be visible in the app list',
  LABEL_COMPANIES_URL_FACEBOOK_ERROR: 'Please indicate a link in this format: https://www.facebook.com/Fidelize or hthis format https://www.facebook.com/share/123456',
  LABEL_COMPANIES_URL_INSTAGRAM_ERROR: 'Please indicate a link in this format: https://www.instagram.com/Fidelize',
  LABEL_COMPANIES_EMAIL_ERROR: 'Please enter a valid email for alerts and reports',
  LABEL_CONNECTED_AS: 'You are connected as {0}',
  LABEL_COUNTRY: 'Country',
  LABEL_DASHBOARD_ACTIVE_CLIENTS: 'Active Clients',
  LABEL_DASHBOARD_ACTIVE_CLIENTS_INFO: 'Active clients in the last month',
  LABEL_DASHBOARD_AGE_DISTRIBUTION:'Age Distribution',
  LABEL_DASHBOARD_GENDER_DISTRIBUTION:'Gender Distribution',
  LABEL_DASHBOARD_GIFTS_GIVEN_W:'Gifts Given (Weekly)',
  LABEL_DASHBOARD_HEATMAP_TITLE: 'Peak Activity Hours',
  LABEL_DAY_MON: 'Mon',
  LABEL_DAY_TUE: 'Tue',
  LABEL_DAY_WED: 'Wed',
  LABEL_DAY_THU: 'Thu',
  LABEL_DAY_FRI: 'Fri',
  LABEL_DAY_SAT: 'Sat',
  LABEL_DAY_SUN: 'Sun',
  LABEL_DASHBOARD_LOCAL_DISTRIBUTION_W:'Points Given by Location (Weekly)',
  LABEL_DASHBOARD_LOCAL_DISTRIBUTION_TOTAL: 'Points Given by Location (Total)',
  LABEL_DASHBOARD_NOTIFICATIONS_W: 'Notifications Sent (Weekly)',
  LABEL_NOTIFICATIONS_POINT: 'Point reminders',
  LABEL_NOTIFICATIONS_GIFT: 'Gift reminders',
  LABEL_DASHBOARD_POINT_CONVERSION: 'Return after reminder (points)',
  LABEL_DASHBOARD_POINT_CONVERSION_INFO: '% who came back after the reminder, before losing the point',
  LABEL_DASHBOARD_GIFT_CONVERSION: 'Return after reminder (gifts)',
  LABEL_DASHBOARD_GIFT_CONVERSION_INFO: '% who redeemed after the reminder, before it expired',
  LABEL_DASHBOARD_RETENTION: 'Point retention',
  LABEL_DASHBOARD_RETENTION_INFO: '% of points renewed rather than expired, across all clients',
  LABEL_DASHBOARD_RATES_TITLE: 'Indicators Over Time',
  LABEL_DASHBOARD_RETENTION_CHART_TITLE: 'Retention Over Time',
  LABEL_DASHBOARD_RETURNS_CHART_TITLE: 'Conversion Rates Over Time',
  LABEL_DASHBOARD_TOP_CLIENTS: 'Most Loyal Clients',
  LABEL_DASHBOARD_TOP_CLIENTS_GIFTS: 'gift|gifts',
  LABEL_DASHBOARD_TOP_CLIENTS_REDEEMED: 'redeemed|redeemed',
  LABEL_DASHBOARD_TOP_CLIENTS_EXPIRED: 'expired|expired',
  LABEL_DASHBOARD_TOP_CLIENTS_PENDING: 'pending|pending',
  LABEL_DASHBOARD_TOP_CLIENTS_NO_GIFTS: 'No gifts yet',
  LABEL_DASHBOARD_TOP_CLIENTS_ANONYMOUS: 'Client',
  LABEL_DASHBOARD_TAB_OVERVIEW: 'Overview',
  LABEL_DASHBOARD_TAB_LOYALTY: 'Are my clients coming back?',
  LABEL_DASHBOARD_TAB_CLIENTS: 'Who are my clients?',
  LABEL_DASHBOARD_TAB_LOCALS: 'Which location performs best?',
  LABEL_DASHBOARD_ENTRY_DISTRIBUTION: 'Entry Method Distribution',
  LABEL_DASHBOARD_ENTRY_NFC: 'NFC',
  LABEL_DASHBOARD_ENTRY_SCAN: 'Scan',
  LABEL_DASHBOARD_ENTRY_CODE: 'Code',
  LABEL_DASHBOARD_ENTRY_UNKNOWN: 'Unknown',
  LABEL_DASHBOARD_MAN:'Male',
  LABEL_DASHBOARD_NEW_CLIENTS: 'New Clients',
  LABEL_DASHBOARD_NEW_CLIENTS_INFO: 'New clients in the last month',
  LABEL_DASHBOARD_NOT_DEFINED:'Not defined',
  LABEL_DASHBOARD_NO_DATA:'No data',
  LABEL_DASHBOARD_NUMBER_OF_CLIENTS:'Number of Clients',
  LABEL_DASHBOARD_NUM_USUARIOS: 'Number of users',
  LABEL_DASHBOARD_NUM_USUARIOS_INFO: 'Total number of users from the beginning',
  LABEL_DASHBOARD_POINTS_GIVEN:'Points Given',
  LABEL_DASHBOARD_POINTS_GIVEN_W:'Points Given/Lost (Weekly)',
  LABEL_DASHBOARD_POINTS_TITLE: 'Points Given/Lost',
  LABEL_DASHBOARD_POINTS_USERS_W: 'New users (Weekly)',
  LABEL_VIEW_WEEKLY: 'Weekly',
  LABEL_VIEW_MONTHLY: 'Monthly',
  LABEL_VIEW_ALL_TIME: 'All time',
  LABEL_DASHBOARD_TOTAL_CLIENTS: 'Total clients',
  LABEL_DASHBOARD_TOTAL_CLIENTS_INFO: 'Total clients from the beginning',
  LABEL_DASHBOARD_W:'W',
  LABEL_DASHBOARD_WOMAN:'Woman',
  LABEL_FEEDBACKS_HEADER_DATE:'Date',
  LABEL_FEEDBACKS_HEADER_MESSAGE:'Message',
  LABEL_FEEDBACKS_HEADER_NOTE:'Note',
  LABEL_FEEDBACKS_HEADER_USER:'User Name',
  LABEL_FEEDBACKS_SEARCH:'Search feedbacks',
  LABEL_IMAGE_REQUIREMENT:'You image should have ration 2/3 (portrait) or 3/2 (landscape) and less than 2MB',
  LABEL_INPUT_CARD_EXPIRATION:'Card Expiration (days)',
  LABEL_INPUT_CODE: 'Code',
  LABEL_INPUT_FACEBOOK_URL:'Facebook URL',
  LABEL_INPUT_GIFT_EXPIRATION:'Gift Expiration (days)',
  LABEL_INPUT_IMAGE:'Image',
  LABEL_INPUT_INSTAGRAM_URL:'Instagram URL',
  LABEL_INPUT_COMPANY_EMAIL: 'Alerts and reports email',
  LABEL_INPUT_MAIL: 'Email',
  LABEL_INPUT_NAME:'Name',
  LABEL_INPUT_NO_IMAGE:'There is no image',
  LABEL_INPUT_PASSWORD:'Password',
  LABEL_INPUT_REQUIREMENT: 'Requirement',
  LABEL_INPUT_USERNAME:'Username',
  LABEL_LOCALS_ADDRESS: 'Address',
  LABEL_LOCALS_ADDRESS_ERROR: 'The address must be between 5 and 60 characters and contain only letters, numbers, or spaces',
  LABEL_LOCALS_ADDRESS_ID: 'Address Id',
  LABEL_LOCALS_ADDRESS_ID_ERROR: 'It must be a Google Maps ID, for example AKHwGeGYTcMbo5Hn6',
  LABEL_LOCALS_ADDRESS_ID_TOOLTIP: 'Retrieve the address id from the Google page',
  LABEL_LOCALS_ADDRESS_TOOLTIP: 'The address as it will appear in the app',
  LABEL_LOCALS_ALERT_DELETE_CONTENT: 'You are about to delete this address, please confirm',
  LABEL_LOCALS_ALERT_DELETE_TITLE: 'Delete an address',
  LABEL_ACTIVITY_ALERT_DELETE_CONTENT: 'You are about to delete this activity, please confirm',
  LABEL_ACTIVITY_ALERT_DELETE_TITLE: 'Delete an activity',
  LABEL_LOCALS_HEADER_ACTIONS: 'Action',
  LABEL_LOCALS_HEADER_ADDRESS:'Address',
  LABEL_LOCALS_HEADER_NAME:'Display Name',
  LABEL_LOCALS_HEADER_PHONE_NUMBER:'Phone Number',
  LABEL_LOCALS_NAME: 'Name',
  LABEL_LOCALS_NAME_ERROR: 'The name must be between 5 and 30 characters and contain only letters, numbers, or spaces',
  LABEL_LOCALS_NAME_TOOLTIP: 'The name that will be displayed in the app for this local',
  LABEL_LOCALS_PHONE: 'Phone',
  LABEL_LOCALS_PHONE_ERROR: 'The contact phone must be in the format tel:973123570 or whatsapp:973123570',
  LABEL_LOCALS_PHONE_TOOLTIP: 'The contact phone for this local, please use whatsapp: or tel:',
  LABEL_LOCALS_SEARCH:'Search locals',
  LABEL_NO: 'No',
  LABEL_NOTIFICATION_ACTION:'Action',
  LABEL_NOTIFICATION_ALERT_DELETE_CONTENT:'You will remove this notification, please confirm',
  LABEL_NOTIFICATION_ALERT_DELETE_TITLE:'Remove a notification',
  LABEL_NOTIFICATION_ANSWER:'Answer',
  LABEL_NOTIFICATION_ANSWER_DESC:'Indicate possibles answer',
  LABEL_NOTIFICATION_ANSWER_ERROR:'Debe indicar entre 2 y 5 respuestas (con 5 hasta 20 caracteres)',
  LABEL_NOTIFICATION_CONTENT:'Content',
  LABEL_NOTIFICATION_CONTENT_DESC:'Then write the content',
  LABEL_NOTIFICATION_CONTENT_ERROR:'El contenido debe ser entre 10 y 100 caracteres y contener solo letras, cifras o espacios',
  LABEL_NOTIFICATION_CREATED: 'Notification has been created',
  LABEL_NOTIFICATION_DATE:'Date',
  LABEL_NOTIFICATION_DATE_DESC:'And select the date and hour you want send it',
  LABEL_NOTIFICATION_DATE_ERROR:'Please select a date and time to send notifications',
  LABEL_NOTIFICATION_NO_DATE: 'No Date',
  LABEL_NOTIFICATION_NO_NOTIFICATION:' There is no notifications, please create your first one',
  LABEL_NOTIFICATION_STANDARD:'Standard',
  LABEL_NOTIFICATION_STATUS:'Status',
  LABEL_NOTIFICATION_SURVEY:'Survey',
  LABEL_NOTIFICATION_TITLE:'Title',
  LABEL_NOTIFICATION_TITLE_DESC:'Please choose a title for the notification',
  LABEL_NOTIFICATION_TITLE_ERROR:'El titulo debe ser entre 5 y 60 caracteres y contener solo letras cifras o espacios',
  LABEL_NOTIFICATION_TOOLTIP_ANSWER: 'Press enter/return key to add your answer',
  LABEL_NOTIFICATION_TOOLTIP_DATE: 'You cannot choose in the next hour, please indicate something after',
  LABEL_NOTIFICATION_TOOLTIP_TYPE: 'Type standard is a simple notification message, survey are questions and you will need to indicate possible answers',
  LABEL_NOTIFICATION_TYPE:'Type',
  LABEL_NOTIFICATION_UPDATED: 'Notification has been updated',
  LABEL_NO_RESULTS: 'No results',
  LABEL_POINTS_GAINED: 'Points gained',
  LABEL_POINTS_LOST: 'Points lost',
  LABEL_PRICING_BASIC_FEATURE_1:'Access to the administration module',
  LABEL_PRICING_BASIC_FEATURE_2:'Manage your company settings',
  LABEL_PRICING_BASIC_FEATURE_3:'Manage your users (max 2 user)',
  LABEL_PRICING_BASIC_FEATURE_4:'Visualize your feedbacks',
  LABEL_PRICING_BASIC_FEATURE_5:'Basic support',
  LABEL_PRICING_BASIC_TITLE:'Plan Basic',
  LABEL_PRICING_CHOSE_PLAN:'Choose your monthly plan',
  LABEL_PRICING_OBJECT_INTERESTED:'Interested in',
  LABEL_PRICING_PREMIUM_FEATURE_1:'Include standard plan',
  LABEL_PRICING_PREMIUM_FEATURE_2:'Up to 3 Local',
  LABEL_PRICING_PREMIUM_FEATURE_3:'10 Notifications',
  LABEL_PRICING_PREMIUM_FEATURE_4:'1 Survey',
  LABEL_PRICING_PREMIUM_FEATURE_5:'Advanced analytics (Gender & Age distribution)',
  LABEL_PRICING_PREMIUM_FEATURE_7:'Priority support',
  LABEL_PRICING_PREMIUM_FEATURE_8: '3 NFC cards',
  LABEL_PRICING_PREMIUM_COMMENT: 'Each additional NFC card: 7,500 CLP (one-time payment)', 
  LABEL_PRICING_PREMIUM_TITLE:'Plan Premium',
  LABEL_PRICING_SCALED_PLAN:'Scaled plan',
  LABEL_PRICING_STANDARD_FEATURE_1:'Include basic plan',
  LABEL_PRICING_STANDARD_FEATURE_2:'Number of users unlimited',
  LABEL_PRICING_STANDARD_FEATURE_3:'Up to 1 Local',
  LABEL_PRICING_STANDARD_FEATURE_4:'4 Notifications',
  LABEL_PRICING_STANDARD_FEATURE_5:'Basic analytics (Points, Gifts, Active clients, New clients)',
  LABEL_PRICING_STANDARD_FEATURE_6:'Advertising on Fidelize Instagram',
  LABEL_PRICING_STANDARD_FEATURE_7:'Standard support',
  LABEL_PRICING_STANDARD_FEATURE_8: 'The Fidelize NFC card',
  LABEL_PRICING_STANDARD_COMMENT: 'Each additional NFC card: 15,000 CLP (one-time payment)',
  LABEL_PRICING_STANDARD_TITLE:'Plan Standard',
  LABEL_RESET_DEFINE_DONE: 'The password has been successfully changed; we will redirect you to log in',
  LABEL_RESET_DEFINE_PASSWORD_CONTENT: 'Please provide your new password and repeat it',
  LABEL_RESET_DEFINE_PASSWORD_TITLE: 'Define new password',
  LABEL_RESET_ERROR_VERIFY: 'Please verify the fields',
  LABEL_RESET_GLOBAL_ERROR: 'There was an error in the process; please try again',
  LABEL_RESET_PASSWORD_1: 'New password',
  LABEL_RESET_PASSWORD_1_ERROR: 'Your password must be at least 6 characters long and contain at least one letter, one number, and one special character',
  LABEL_RESET_PASSWORD_2: 'Password confirmation',
  LABEL_RESET_PASSWORD_2_ERROR: 'Please repeat your new password',
  LABEL_RESET_PASSWORD_CONTENT: 'No problem, just provide your email and we will send you a link to reset it',
  LABEL_RESET_PASSWORD_MAIL_ERROR: 'Please provide a valid email',
  LABEL_RESET_PASSWORD_RESET_DONE: 'If this email belongs to an account, you will receive a link to reset your password. Please also check your spam folder.',
  LABEL_RESET_PASSWORD_TITLE: 'Forgot your password?',
  LABEL_USERS_HEADER_ACTIONS:'Action',
  LABEL_USERS_HEADER_CONNECTIONS:'Connections',
  LABEL_USERS_HEADER_DOB: 'Date of birth',
  LABEL_USERS_HEADER_GENDER: 'Gender',
  LABEL_USERS_HEADER_NAME:'Display Name',
  LABEL_USERS_HEADER_PLATFORM:'Platform',
  LABEL_USERS_HEADER_STATUS: 'Status',
  LABEL_USERS_SEARCH:'Search users',
  LABEL_WARNING_ADVERTISING:'Please fill the advertising form to activate the functionality',
  LABEL_YES: 'Yes',
};
export default dictionary;
